import React from "react";
import "./About.css";
const About = () => {
  return (
    <div>
      <section className="about" id="about">
        <div className="content">
          <div className="title">
            <span>About Me</span>
          </div>
          <div className="about-details">
            <div className="left">
              <img
                src="https://i.ibb.co/xffMZhq/66619451-2373035856298397-7928832343668686848-o.jpg"
                alt="Portfolio"
              />
            </div>
            <div className="right">
              <div className="topic">Programming Is My Passion</div>
              <p>
                Welcome to my mini portfolio website! This is Morshed Alam. I am
                a full stack developer and currently staying in Bangladesh. I am
                a person, who has high passion in web development, Mobile
                application development. One of my dreams is to master all the
                technologies and become one of the TOP developer in the world,
                and now, I am working toward it!
              </p>
              <div className="button">
                <a
                  className="d-block btn btn-outline-light"
                  href="https://drive.google.com/uc?export=download&id=1LcGV_4ItRViS85k3v4IB9tPnsVRC0gbx"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  Download Resume{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
